// import React, { useState, useEffect, useContext } from 'react';
// import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
// import ReusableTable from '../../../Layout/ReusableTable';
// import Navbar from "../../../Shared/AdminNavbar/Navbar";
// import { AuthContext } from '../../../AuthContext/Authcontext';
// import axios from 'axios';
// import baseURL from "../../../Apiurs/Apiurls";
// import { useNavigate } from "react-router-dom";
// import './AllTeams.css';

// const AdminCustomer = () => {
//   const { userName, userEmail } = useContext(AuthContext);
//   const [collapsed, setCollapsed] = useState(false);
//   const [message, setMessage] = useState("");
//   const [managers, setManagers] = useState([]);
//   const navigate = useNavigate();

//   const handleAddEmployee = () => {
//     navigate('/addemployee');
//   };

//   useEffect(() => {
//     const fetchManagers = async () => {
//       try {
//         const response = await axios.get(`${baseURL}/api/employees/managers`);
//         setManagers(response.data.data);
//       } catch (error) {
//         console.error("Error fetching managers:", error);
//       }
//     };
//     fetchManagers();
//   }, []);

//   const handleDeleteEmployee = async (id) => {
//     try {
//       const response = await axios.delete(`${baseURL}/api/employees/${id}`);
//       if (response.status === 204) {
//         setManagers(managers.filter(manager => manager.id !== id));
//         setMessage("Employee deleted successfully!");
//         setTimeout(() => setMessage(""), 3000);
//       }
//     } catch (error) {
//       console.error("Error deleting employee:", error);
//       setMessage("Failed to delete employee. Please try again.");
//       setTimeout(() => setMessage(""), 3000);
//     }
//   };

//   const columns = [
//     {
//       key: "id",
//       title: "Employee ID",
//       render: (row) => `EMP${String(row.id).padStart(5, "0")}`,
//     },
//     {
//       key: "name",
//       title: "Name",
//       render: (row) => row.name,
//     },
//     {
//       key: "mobile",
//       title: "Mobile No",
//       render: (row) => row.mobile,
//     },
//     {
//       key: "email",
//       title: "Email",
//       render: (row) => row.email,
//     },
//     {
//   key: "role",
//   title: "Designation",
//   render: (row) =>
//     row.role === "s-manager"
//       ? "Sales Manager"
//       : row.role === "manager"
//       ? "Quotation Manager"
//       : row.role,
// },

//     {
//       key: "teamMembers",
//       title: "No. of Team Members",
//       render: (row) => (
//         <button
//           className="btn btn-link"
//           onClick={() => navigate('/team-members', { state: { teamMembers: row.teamMembers } })}
//         >
//           {row.employeeCount}
//         </button>
//       ),
//     },
//     {
//       key: "actions",
//       title: "Actions",
//       render: (row) => (
//         <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
//           <FaEye
//             style={{ color: "#ff9966", cursor: "pointer" }}
//             onClick={() => navigate('/team-members', { state: { teamMembers: row.teamMembers } })}
//             title="View"
//           />
//           <FaEdit
//             style={{ color: "#ff9966", cursor: "pointer" }}
//             onClick={() => navigate(`/editemployee/${row.id}`)}
//             title="Edit"
//           />
//           <FaTrash
//             style={{ color: "#ff9966", cursor: "pointer" }}
//             onClick={() => handleDeleteEmployee(row.id)}
//             title="Delete"
//           />
//         </div>
//       ),
//     },
//   ];

//   return (
//     <div className="Admin-myteamcontainer">
//       <Navbar onToggleSidebar={setCollapsed} />
//       <div className={`Admin-myteam ${collapsed ? "collapsed" : ""}`}>
//         <div className="ViewCustomer-container mb-5">
//           <div className="ViewCustomer-table-container">
//             <h3 className="d-flex justify-content-between align-items-center w-100">
//               <span></span>
//               <button className="btn btn-primary" onClick={handleAddEmployee}>
//                 + Add Employee
//               </button>
//             </h3>
//             {message && <div className="alert alert-success">{message}</div>}
//             <ReusableTable
//               title="All Employees"
//               data={managers}
//               columns={columns}
//               initialEntriesPerPage={5}
//               searchPlaceholder="Search employees..."
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminCustomer;


import React, { useState, useEffect, useContext } from 'react';
import { FaEdit, FaTrash, FaEye, FaUsers } from "react-icons/fa";
import ReusableTable from '../../../Layout/ReusableTable';
import Navbar from "../../../Shared/AdminNavbar/Navbar";
import { AuthContext } from '../../../AuthContext/Authcontext';
import axios from 'axios';
import baseURL , {defaultManagerId} from "../../../Apiurs/Apiurls";
import { useNavigate } from "react-router-dom";
import './AllTeams.css';

const AdminCustomer = () => {
  const { userName, userEmail } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [message, setMessage] = useState("");
  const [managers, setManagers] = useState([]);
  const [salesManager, setSalesManager] = useState(null); // 🔹 store default sales manager data
  const navigate = useNavigate();

  const handleAddEmployee = () => {
    navigate('/addemployee');
  };

  useEffect(() => {
    const fetchManagers = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/employees/managers`);
        if (response.data?.data) {
          // 🔹 Find the default Sales Manager (ID = defaultManagerId)
          const defaultSalesManager = response.data.data.find(m => m.id === defaultManagerId);

          // 🔹 Filter out Sales Manager row (we won’t display it)
          const filteredManagers = response.data.data.filter(m => m.role !== "s-manager");

          setManagers(filteredManagers);
          setSalesManager(defaultSalesManager);
        }
      } catch (error) {
        console.error("Error fetching managers:", error);
      }
    };
    fetchManagers();
  }, []);

  const handleDeleteEmployee = async (id) => {
    try {
      const response = await axios.delete(`${baseURL}/api/employees/${id}`);
      if (response.status === 204) {
        setManagers(managers.filter(manager => manager.id !== id));
        setMessage("Employee deleted successfully!");
        setTimeout(() => setMessage(""), 3000);
      }
    } catch (error) {
      console.error("Error deleting employee:", error);
      setMessage("Failed to delete employee. Please try again.");
      setTimeout(() => setMessage(""), 3000);
    }
  };

  // 🔹 View Sales Associates under default Sales Manager (ID defaultManagerId)
  const handleViewSalesAssociates = () => {
    if (!salesManager) {
      setMessage("Default Sales Manager data not found.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }
    navigate('/team-members', { state: { teamMembers: salesManager.teamMembers } });
  };

  const columns = [
    {
      key: "id",
      title: "Employee ID",
      render: (row) => `EMP${String(row.id).padStart(5, "0")}`,
    },
    {
      key: "name",
      title: "Name",
      render: (row) => row.name,
    },
    {
      key: "mobile",
      title: "Mobile No",
      render: (row) => row.mobile,
    },
    {
      key: "email",
      title: "Email",
      render: (row) => row.email,
    },
    {
      key: "role",
      title: "Designation",
      render: (row) =>
        row.role === "manager"
          ? "Quotation Manager"
          : row.role === "s-employee"
          ? "Sales Associate"
          : row.role,
    },
    {
      key: "teamMembers",
      title: "No. of Team Members",
      render: (row) => (
        <button
          className="btn btn-link"
          onClick={() =>
            navigate('/team-members', { state: { teamMembers: row.teamMembers } })
          }
        >
          {row.employeeCount}
        </button>
      ),
    },
    {
      key: "actions",
      title: "Actions",
      render: (row) => (
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <FaEye
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() =>
              navigate('/team-members', { state: { teamMembers: row.teamMembers } })
            }
            title="View"
          />
          <FaEdit
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => navigate(`/editemployee/${row.id}`)}
            title="Edit"
          />
          <FaTrash
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => handleDeleteEmployee(row.id)}
            title="Delete"
          />
        </div>
      ),
    },
  ];

  return (
    <div className="Admin-myteamcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Admin-myteam ${collapsed ? "collapsed" : ""}`}>
        <div className="ViewCustomer-container mb-5">
          <div className="ViewCustomer-table-container">
            <h3 className="d-flex justify-content-between align-items-center w-100">
              {/* 🔹 Left side buttons */}
              <div className="d-flex gap-3">
                <button
                  className="btn btn-outline-primary d-flex align-items-center gap-2"
                  onClick={handleViewSalesAssociates}
                >
                  <FaUsers /> View Sales Associates
                </button>
              </div>

              {/* 🔹 Right side button */}
              <button className="btn btn-primary" onClick={handleAddEmployee}>
                + Add Employee
              </button>
            </h3>

            {message && <div className="alert alert-success">{message}</div>}

            <ReusableTable
              title="All Employees"
              data={managers}
              columns={columns}
              initialEntriesPerPage={5}
              searchPlaceholder="Search employees..."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCustomer;
